import { Pipe, PipeTransform } from '@angular/core';

import { UtilsPcvizService } from '@mirage-projects/cw-pcviz-core';

@Pipe({
    name: 'CRSName',
    standalone: false,
})
export class CRSNamePipe implements PipeTransform {
    constructor(private utilsService: UtilsPcvizService) {}

    async transform(code: string | undefined | null): Promise<string> {
        if (!code) {
            return '';
        }

        const crsCode = code.split('EPSG:')[1];
        const datum = await this.utilsService.getCRSUtils().getCRSDatum(crsCode);

        return `${datum} (${code})`;
    }
}
